var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultNoCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 194,
    viewBox: "0 0 325 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 194,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 325,
    height: 193.86,
    rx: 10,
    fill: "#0020BF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_444_6612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 325,
    height: 194
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 193.86,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_444_6612)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.0527,
    y: 103.053,
    width: 34.7368,
    height: 25.2632,
    rx: 5,
    fill: "#F3E2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8418 110.422C59.3941 110.422 59.8418 110.87 59.8418 111.422V119.948C59.8418 120.5 59.3941 120.948 58.8418 120.948H47.2102C45.4662 120.948 44.0523 119.534 44.0523 117.79V113.58C44.0523 111.836 45.4662 110.422 47.2102 110.422H58.8418Z",
    fill: "#F7CB6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3154 111.474V119.895C59.3154 120.185 59.0798 120.421 58.7891 120.421H47.2102C45.7568 120.421 44.5786 119.243 44.5786 117.789V113.579C44.5786 112.881 44.8558 112.212 45.3494 111.718C45.8429 111.225 46.5122 110.947 47.2102 110.947H58.7891C59.0798 110.947 59.3154 111.183 59.3154 111.474Z",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_444_6612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71572 6.71573 0 15 0H310C318.284 0 325 6.71573 325 15V179C325 187.284 318.284 194 310 194H15C6.71573 194 0 187.284 0 179V15Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.999 52.2178C91.8053 53.3055 91.6104 54.3933 91.4191 55.481C91.3625 55.8002 91.3144 56.1195 91.2494 56.523C77.3447 53.5777 63.4713 50.6385 49.5342 47.686C49.7255 46.4332 49.9096 45.2238 50.0949 44.0156C50.1298 43.7879 50.1514 43.5578 50.2008 43.3338C50.569 41.6799 52.0478 40.7198 53.713 41.0727C64.1127 43.276 74.5123 45.4864 84.9107 47.692C86.2595 47.9787 87.6036 48.3004 88.9632 48.5256C90.4492 48.7726 91.5454 49.4387 92.0002 50.9481V52.2178H91.999Z",
    fill: "#D6B07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7566 76.1849C80.1284 77.5594 80.5122 78.8254 80.8094 80.1108C81.1885 81.755 80.3594 83.1283 78.717 83.6089C76.6956 84.2004 74.6633 84.7545 72.6334 85.3183C62.8547 88.0335 53.0735 90.745 43.2948 93.4602C41.2119 94.0384 39.7909 93.2482 39.217 91.1787C37.2015 83.8992 35.1885 76.621 33.1755 69.3416C32.6172 67.3215 33.3993 65.9 35.4039 65.3351C38.7766 64.3858 42.1517 63.439 45.534 62.5235C46.0261 62.3898 46.2427 62.1766 46.3426 61.6767C46.8275 59.2313 47.3509 56.7944 47.8635 54.3551C47.8899 54.2274 47.9405 54.1045 47.9958 53.9238C49.2496 54.1888 50.4805 54.449 51.7114 54.7104C55.7399 55.5657 59.7671 56.4258 63.798 57.269C64.0471 57.3208 64.3347 57.2787 64.5849 57.2112C66.7857 56.6209 68.9756 55.9861 71.1835 55.426C72.5468 55.079 73.9281 55.8392 74.4359 57.163C74.6825 57.8051 74.8751 58.4748 75.0146 59.1482C75.1049 59.5843 75.3323 59.73 75.7245 59.8119C80.1681 60.7395 84.6093 61.6791 89.0517 62.6163C89.255 62.6596 89.4535 62.7199 89.6846 62.7801C89.2069 65.058 88.7376 67.3082 88.2611 69.556C87.9002 71.2629 87.5428 72.9711 87.1602 74.6732C86.7511 76.4897 85.3288 77.3751 83.4975 76.9836C82.2834 76.7246 81.0706 76.4644 79.7566 76.1837V76.1849ZM37.9716 77.7618C38.0306 77.9931 38.0739 78.1774 38.1244 78.3617C39.2483 82.4248 40.3733 86.4879 41.4983 90.5511C41.7125 91.3268 41.8677 91.416 42.6438 91.1992C54.3574 87.9419 66.0697 84.6846 77.7833 81.4274C78.5642 81.2106 78.6436 81.0696 78.427 80.283C77.6798 77.5666 76.9338 74.8502 76.1818 72.1351C75.7594 70.6064 75.3275 69.0802 74.8859 67.5058C62.5743 70.9256 50.3109 74.3335 37.9716 77.7618ZM36.5626 72.7494C48.8995 69.3211 61.1797 65.9085 73.4949 62.4862C73.1135 61.0961 72.7549 59.7854 72.394 58.476C72.1822 57.7075 72.021 57.6159 71.2413 57.8328C62.2542 60.3275 53.2684 62.8235 44.2826 65.3182C41.5332 66.0819 38.7838 66.8432 36.032 67.6021C35.6121 67.7178 35.2294 67.8683 35.375 68.4128C35.7588 69.8547 36.1619 71.2918 36.5614 72.7494H36.5626ZM78.7266 68.7802C78.6978 69.7246 78.9769 70.1655 79.6315 70.3149C80.9731 70.6209 82.3207 70.91 83.6744 71.1581C84.5588 71.3195 85.0172 70.9786 85.2085 70.1065C85.4588 68.9657 85.6886 67.8214 85.9365 66.6794C86.2325 65.3194 85.9858 64.9159 84.6285 64.6147C83.5083 64.3666 82.3857 64.1268 81.2631 63.8944C80.4208 63.7197 79.8432 63.9281 79.6664 64.6111C79.2873 66.0723 78.9974 67.5564 78.7266 68.7802Z",
    fill: "#BE9157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3234 86.0313C49.244 86.6384 48.9636 87.06 48.3392 87.2419C46.9602 87.6455 45.5741 88.0249 44.1844 88.3851C43.5659 88.5453 42.998 88.2634 42.8079 87.6418C42.3723 86.212 41.9716 84.7701 41.619 83.3173C41.4482 82.615 41.7851 82.1127 42.4818 81.9055C43.8402 81.502 45.2059 81.1201 46.5776 80.7635C47.1239 80.6214 47.7171 80.7563 47.9036 81.3032C48.4318 82.8608 48.8578 84.452 49.3234 86.0301V86.0313Z",
    fill: "#D6B07F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_444_6612",
    x: -16,
    y: -16,
    width: 357,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_444_6612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_444_6612",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultNoCard);
export default __webpack_public_path__ + "static/media/default-no-card.a4920370bce37722c450f8cb54043205.svg";
export { ForwardRef as ReactComponent };